import {
  Backdrop,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import EditIcon from "@material-ui/icons/Edit";
import React, { useState } from "react";
import { connect } from "react-redux";
import { actions } from "../../../redux/actions/alert";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import Transition from "../../stateless/Transition";
import styles from "../../../styles/global-styles";
import { AuthService } from "../../../services/auth.service";
import { UserService } from "../../../services/user.service";

const useStyles = makeStyles((theme) => ({
  label: {
    marginBottom: "1.5vh",
  },
  box: {
    marginTop: "20px",
  },
  formControl: styles.globalFormControl,
  subtitle: styles.subtitle,
  rightButton: styles.buttonRightHeader,
  backdrop: styles.backdrop,
}));

const UpdatePassword = ({ addAlert, detailAlert, open, currentUser }) => {
  const classes = useStyles();
  const [userObject, setUserObject] = useState({ id: currentUser.id });
  const [showBackdrop, setShowBackDrop] = useState(false);

  ValidatorForm.addValidationRule("passwordLength", (value) =>
    value.length < 6 ? false : true
  );

  ValidatorForm.addValidationRule("isPasswordMatch", (value) => {
    return value !== userObject.password ? false : true;
  });

  const handleSubmitForm = async () => {
    try {
      const { status } = await UserService.verifiedUser(userObject);
      if (status === 200) {
        setTimeout(() => AuthService.logout(), 2000);
        addAlert({ showAlert: true });
        detailAlert({
          severity: "success",
          message: "Contraseña actualizada exitosamente",
        });
        setShowBackDrop(true);
      }
    } catch (error) {
      addAlert({ showAlert: true });
      detailAlert({ severity: "error", message: error.msgs });
    }
  };

  const handleInputText = ({ target: { name, value } }) => {
    setUserObject({ ...userObject, [name]: value });
  };

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={open}
      keepMounted
      TransitionComponent={Transition}
      aria-labelledby="simple-dialog-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <ValidatorForm
        onSubmit={handleSubmitForm}
        onError={(errors) => console.log(errors)}
      >
        <Grid container direction="column" justify="center" alignItems="center">
          <Grid item>
            <Typography
              style={{ textAlign: "center", marginTop: 30 }}
              variant="h4"
              component="h4"
              className={classes.subtitle}
            >
              ¡ Bienvenid@ {currentUser.name} !
            </Typography>

            <DialogContent>
              <DialogContentText>
                Actualizar tu contraseña para poder continuar.
              </DialogContentText>

              <Box className={classes.box}>
                <Typography
                  variant="body2"
                  component={"div"}
                  className={classes.label}
                >
                  Nueva contraseña
                </Typography>
                <TextValidator
                  name="password"
                  type="password"
                  onChange={(e) => handleInputText(e)}
                  value={userObject.password || ""}
                  validators={["required", "passwordLength"]}
                  errorMessages={[
                    "La contraseña es obligatoria",
                    "La contraseña debe tener mas de 6 caractéres",
                  ]}
                  variant="outlined"
                  inputProps={{
                    maxLength: 20,
                  }}
                />
              </Box>

              <Box className={classes.box}>
                <Typography
                  variant="body2"
                  component={"div"}
                  className={classes.label}
                >
                  Repetir contraseña
                </Typography>
                <TextValidator
                  name="repeatPassword"
                  type="password"
                  onChange={(e) => handleInputText(e)}
                  value={userObject.repeatPassword || ""}
                  validators={["required", "passwordLength", "isPasswordMatch"]}
                  errorMessages={[
                    "La contraseña es obligatoria",
                    "La contraseña debe tener mas de 6 caractéres",
                    "La contraseña debe de ser la misma",
                  ]}
                  variant="outlined"
                  inputProps={{
                    maxLength: 20,
                  }}
                />
              </Box>
            </DialogContent>
          </Grid>

          <Grid item style={{ marginBottom: 40 }}>
            <Button
              className={classes.rightButton}
              variant="contained"
              color="primary"
              endIcon={<EditIcon color="secondary" />}
              type="submit"
            >
              Actualizar
            </Button>
          </Grid>
        </Grid>
      </ValidatorForm>
      <Backdrop className={classes.backdrop} open={showBackdrop}>
        <CircularProgress color="inherit" size={80} />
      </Backdrop>
    </Dialog>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(undefined, dispatch)(UpdatePassword);
